import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TgGridModule, TgInfoBoxModule, TgInputModule, TgSelectModule } from '@trademe/tangram';
import { PropertyFeaturesSectionComponent } from './property-features-section.component';
import { DraftValidationModule } from '@classifieds-sell/shared';
import { PropertySideCardModule } from '../../../components/property-side-card/property-side-card.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgSelectModule,
        TgInputModule,
        TgGridModule,
        DraftValidationModule,
        TgInfoBoxModule,
        PropertySideCardModule
    ],
    declarations: [PropertyFeaturesSectionComponent],
    exports: [PropertyFeaturesSectionComponent]
})
export class PropertyFeatureSectionModule { }
